import { FC } from "react";
import RichText from "src/components/RichText/RichTextUnstyled";

export function decodeHtmlEntities(html: string) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
}

const HTML_VALUE_CLASSNAME =
  "text-sm font-medium text-font-subtle [&>ol]:list-decimal [&>ol]:space-y-1 [&>ol]:ps-5 [&>p]:mb-2 [&>ul]:list-disc [&>ul]:space-y-1 [&>ul]:ps-5";

export const RateConditionRow: FC<{ condition: string }> = ({ condition }) => {
  const decoded = decodeHtmlEntities(condition);
  const firstTagIndex = decoded.search(/<[a-z][^>]*>/i);

  if (firstTagIndex !== -1) {
    const prefixLabel = decoded.slice(0, firstTagIndex).replace(/:\s*$/, "").trim();
    const htmlValue = decoded.slice(firstTagIndex);

    return (
      <div className="flex flex-col gap-1">
        {prefixLabel && <span className="font-bold tracking-wide">{prefixLabel}</span>}
        <RichText html={htmlValue} className={HTML_VALUE_CLASSNAME} />
      </div>
    );
  }

  const [label, ...rest] = condition.split(":");

  if (rest.length === 0) {
    return <RichText html={decoded} className="font-medium" />;
  }

  const value = rest.join(":").trim();

  return (
    <div className="flex flex-col gap-1">
      <span className="font-bold tracking-wide">{label.trim()}</span>
      {value && <RichText html={decodeHtmlEntities(value)} className="text-font-subtle text-sm font-medium" />}
    </div>
  );
};
